// extracted by mini-css-extract-plugin
module.exports = {"buildcontrols_container":"buildcontrols_buildcontrols_container__2O0cx","OrderButton":"buildcontrols_OrderButton__2w3FH","enable":"buildcontrols_enable__2H5M9"};